import React from 'react'
import './svg.scss'

const RemoveCutSVG = () => (
  <>
    <svg className="minus-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M140 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H140zm364-28c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z" /></svg>
  </>
)

export default RemoveCutSVG
